module.exports = __webpack_public_path__ + "assets/img/7194-bf.svg";